import {ITheme} from 'contexts/ThemeContext';
import {StyleSheet, ViewStyle} from 'react-native';

export default (props: ITheme) =>
  StyleSheet.create({
    container: {
      width: 33,
      height: 33,
      borderRadius: 8,
      justifyContent: 'center',
      alignItems: 'center',
      boxShadow: `1px 1px 10px ${props.colors.shadowGrey}`,
    },
    image: {
      width: 20,
      height: 20,
    },
  });
